// 登录方式
export const LOGIN_TYPE = {
  role_id: 1,
  app: 2,
  in_game: 3,
  role_id_safe: 4,
}

export const LOGIN_TYPE_MAP = {
  [LOGIN_TYPE.role_id]: {
    value: 'role_id',
    label: 'role_id',
  },
  [LOGIN_TYPE.app]: {
    value: 'app',
    label: 'app',
  },
  [LOGIN_TYPE.in_game]: {
    value: 'in_game',
    label: 'in_game',
  },
  [LOGIN_TYPE.role_id_safe]: {
    value: 'role_id_safe',
    label: 'role_id_safe',
  },
}

export const GATEWAY_MAP = {
  paypal: 0,
  paypal_paylater: 1001,
  adyen: 75,
  kakao: 7501,
  paypay: 7502,
  primer: 83,
  google_pay: 8302,
  apple_pay: 8301,
  payermax: 84,
  deepgrow: 90,
}

export const PAY_WAY_MAP = {
  0: 'paypal',
  1001: 'paypal_paylater',
  75: 'adyen',
  7501: 'kakao',
  7502: 'paypay',
  83: 'primer',
  8302: 'google_pay',
  8301: 'apple_pay',
  84: 'payermax',
  90: 'deepgrow',
}

export const PRIMER_FAIL_KEY = {
  default: 'fail.change',
  INSUFFICIENT_FUNDS: 'fail.nomoney_new',
  DO_NOT_HONOR: 'fail.bankerr_new',
  DECLINED: 'fail.bankerr_new',
  REFER_TO_CARD_ISSUER: 'fail.bankerr_new',
  WITHDRAWAL_LIMIT_EXCEEDED: 'fail.huge_new',
  ISSUER_TEMPORARILY_UNAVAILABLE: 'fail.reload_new',
  INVALID_CARD_NUMBER: 'fail.none_new',
  EXPIRED_CARD: 'fail.over_new',
}

export const PRIMER_ORDER_STATUS = {
  PENDING: 0,
  PAID: 1,
  FAILED: 2,
  SHIP_BLOCKED: 3,
}

// 邮编错误类型
export const POSTCODE_ERROR_TYPE = {
  // 数据为空
  EMPTY: 'empty',
  // 数据长度错误
  INVALID_LENGTH: 'invalid_length',
  // 数据格式错误
  INVALID_FORMAT: 'invalid_format',
}

export const SEND_CODE_ERROR_KEY = {
  101031017: 'login.code_error_1',
  101031018: 'login.code_error_2',
  101031019: 'login.code_error_3',
  101031020: 'login.code_error_6',
  101031021: 'login.code_error_5',
  default: 'login.code_error_3',
}

export default {
  LOGIN_TYPE,
  LOGIN_TYPE_MAP,
  GATEWAY_MAP,
  PAY_WAY_MAP,
  PRIMER_FAIL_KEY,
  PRIMER_ORDER_STATUS,
  POSTCODE_ERROR_TYPE,
  SEND_CODE_ERROR_KEY,
}
